import * as Yup from "yup";

export const userSignupSchema = Yup.object().shape({
    parentName: Yup.string().trim().max(50).required(),
    email: Yup.string().trim().lowercase().required().email().max(250),
    phone: Yup.string().trim().required(),
    password: Yup.string().trim().required(),
    childName: Yup.string().trim().required(),
    birthday: Yup.date().required(),
    childCondition: Yup.string().trim().required(),
    childReport: Yup.array().of(Yup.string().url()).min(1)
});

export const specialistSignupSchema = Yup.object().shape({
    fullName: Yup.string().trim().max(50).required(),
    email: Yup.string().trim().lowercase().required().email().max(250),
    phone: Yup.string().trim().required(),
    password: Yup.string().trim().required(),
    brief: Yup.string().trim().required(),
    city: Yup.string().trim().required(),
    district: Yup.string().trim().required(),
    degree: Yup.string().trim().required(),
    specialization: Yup.string().trim().required(),
    yearsOfExperience: Yup.number().required(),
    gender: Yup.string().trim().oneOf(['male', 'female']).required(),
    image: Yup.string().url().trim().required(),
    graduationCertificate: Yup.string().url().trim().required(),
    resume: Yup.string().url().trim().required(),
    ID_card: Yup.string().url().trim().required(),
});

export const loginSchema = Yup.object().shape({
    email: Yup.string().trim().email().required(),
    password: Yup.string().trim().min(8).required()
});
